module.exports = "<div class=\"cart-page\" md-dynamic-height=\"md-dynamic-height\" md-border-bottom=\"md-border-bottom\"><cartonomy-cart ng-show=\"orderExists\" ng-class=\"{'is-mobile': isMobile() }\"></cartonomy-cart></div>"


//////////////////
// WEBPACK FOOTER
// ./src/modules/cart/views/cartView.pug
// module id = 772
// module chunks = 0